import {
  TableContainer,
  Paper,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
} from "@mui/material";
import React from "react";
import RenderField from "../RenderField";
import InputField from "models/input/input-field";

const TableField = ({ field }: { field: InputField }) => {
  return (
    <TableContainer component={Paper}>
      <Table>
        <TableHead>
          <TableRow>
            {(
              field.data.headers as {
                label: string;
                position: number;
                field_type: string;
              }[]
            ).map((header) => (
              <TableCell key={`table-header-${header.label}`}>
                {header.label}
              </TableCell>
            ))}
          </TableRow>
        </TableHead>
        <TableBody>
          {(field.data.data as Record<string, string>[]).map(
            (row: Record<string, string>, index: number) => (
              <TableRow
                key={`table-row-${index}`}
                sx={
                  ["nrdata-orig", "FAF-nt"].includes(
                    process.env.REACT_APP_STYLING_THEME ?? "",
                  )
                    ? {
                        boxShadow:
                          (index - 1) % 2
                            ? "inset 0 0 0 9999px rgba(0, 0, 0, 0.05);"
                            : undefined,
                      }
                    : undefined
                }
              >
                {(
                  field.data.headers as {
                    label: string;
                    position: number;
                    field_type: string;
                    display_type: string;
                  }[]
                ).map((header) => {
                  return (
                    <TableCell
                      key={`label-${index}-${header.label}`}
                      sx={
                        ["nrdata-orig", "FAF-nt"].includes(
                          process.env.REACT_APP_STYLING_THEME ?? "",
                        )
                          ? {
                              border: "1px solid #e6e6e6",
                            }
                          : undefined
                      }
                    >
                      <RenderField
                        field={{
                          ...header,
                          data: row[header.label],
                          table: true,
                        }}
                      />
                    </TableCell>
                  );
                })}
              </TableRow>
            ),
          )}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default TableField;
